export enum ProviderType {
  SF = 'salesforce',
  HS = 'hubspot',
  CSV = 'csv',
  HubspotList = 'hubspot/list',
}

export enum AccountType {
  SF = 'salesforce',
  HS = 'hubspot',
  SFGC = 'salesforce-gc',
}

export enum Operation {
  PULL = 'pull',
  INSERT = 'insert',
  UPDATE = 'update',
  DELETE = 'delete',
}

export interface FilterCondition {
  fieldName: string;
  type: string;
  operator: string;
  value: any;
  joinOperator: string;
}

export interface ColumnFieldMapping {
  columnName: string;
  fieldName: string;
  alternativeColumnName?: string;
}

export type Flowstep = {
  id: any;
  name: string;
  flowId?: string;
  errorReaction: string;
  operation: Operation;
  provider: ProviderType;
  options: Record<string, any>;
  providerOptions: Record<string, any>;
  version: string;
};

type OldFlowstep = Record<string, any>;
type NewFlowstepFormat = Record<string, any> & { originalFlowstep: Flowstep };
export type MigrationFlowstep = OldFlowstep | NewFlowstepFormat;

export const isNewFlowstepFormat = (flowstep: MigrationFlowstep): flowstep is NewFlowstepFormat =>
  'originalFlowstep' in flowstep;

export enum PullMode {
  OVERWRITE = 'overwrite',
  APPEND = 'append',
  NEW_SHEET = 'new-sheet',
}
